'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var svgIcon = require('./svg-icon-501cae97.js');

var Close = function (_a) {
    var dataCy = _a.dataCy, className = _a.className, variant = _a.variant, size = _a.size, svgProps = tslib_es6.__rest(_a, ["dataCy", "className", "variant", "size"]);
    return (React__default.createElement(svgIcon.SvgIcon, tslib_es6.__assign({ viewBox: "0 0 50 50", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", className: className, variant: variant, size: size, "data-cy": dataCy }, svgProps),
        React__default.createElement("defs", null,
            React__default.createElement("polygon", { id: "close-icon-path-1", points: "50 5.06872852 30.0687285 25 50 44.9312715 44.9312715 50 25 30.0687285 5.06872852\n        50 0 44.9312715 19.9312715 25 0 5.06872852 5.06872852 0 25 19.9312715 44.9312715 0" })),
        React__default.createElement("g", { id: "Atoms-/-Icons-/-X", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React__default.createElement("mask", { id: "close-icon-mask-2", fill: "white" },
                React__default.createElement("use", { xlinkHref: "#close-icon-path-1" })),
            React__default.createElement("use", { id: "Icon", fill: "#7E7E7E", xlinkHref: "#close-icon-path-1" }),
            React__default.createElement("g", { id: "Atoms-/-Colors-/-defaultBlack", mask: "url(#close-icon-mask-2)", fill: "currentColor" },
                React__default.createElement("rect", { id: "Square", x: "0", y: "0", width: "50", height: "50" })))));
};

exports.Close = Close;
